import { render, staticRenderFns } from "./FormLaskuHyvita.vue?vue&type=template&id=23cec296&scoped=true&"
import script from "./FormLaskuHyvita.vue?vue&type=script&lang=js&"
export * from "./FormLaskuHyvita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cec296",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VDatePicker,VForm,VMenu,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23cec296')) {
      api.createRecord('23cec296', component.options)
    } else {
      api.reload('23cec296', component.options)
    }
    module.hot.accept("./FormLaskuHyvita.vue?vue&type=template&id=23cec296&scoped=true&", function () {
      api.rerender('23cec296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormLaskuHyvita.vue"
export default component.exports